export const EXCMDEVICESTATE_DELETE_RESET = 'EXCMDEVICESTATE_DELETE_RESET'
export const EXCMDEVICESTATE_DELETE_SET_ERROR = 'EXCMDEVICESTATE_DELETE_SET_ERROR'
export const EXCMDEVICESTATE_DELETE_SET_DELETED = 'EXCMDEVICESTATE_DELETE_SET_DELETED'
export const EXCMDEVICESTATE_DELETE_TOGGLE_LOADING = 'EXCMDEVICESTATE_DELETE_TOGGLE_LOADING'
